/**
 * Utility function to clear all localStorage data
 * This will remove all user preferences and persistent data from the application
 */
export const clearAllStorage = () => {
    // Clear everything from localStorage
    localStorage.clear();
};
